import { CONST_ROWS_PER_PAGE } from '@commons/consts';
import {
    NEW_IMPLANTACAO_ESTOQUE_SUCCESS,
    TABLE_IMPLANTACAO_ESTOQUE_PENDING,
    TABLE_IMPLANTACAO_ESTOQUE_SUCCESS,
    TABLE_IMPLANTACAO_ESTOQUE_FAILURE,
    LIST_IMPLANTACAO_ESTOQUE_PENDING,
    LIST_IMPLANTACAO_ESTOQUE_SUCCESS,
    LIST_IMPLANTACAO_ESTOQUE_FAILURE,
    FIND_IMPLANTACAO_ESTOQUE_PENDING,
    FIND_IMPLANTACAO_ESTOQUE_SUCCESS,
    FIND_IMPLANTACAO_ESTOQUE_FAILURE,
    DELETE_IMPLANTACAO_ESTOQUE_PENDING,
    DELETE_IMPLANTACAO_ESTOQUE_SUCCESS,
    DELETE_IMPLANTACAO_ESTOQUE_FAILURE,
    CREATE_IMPLANTACAO_ESTOQUE_PENDING,
    CREATE_IMPLANTACAO_ESTOQUE_SUCCESS,
    CREATE_IMPLANTACAO_ESTOQUE_FAILURE,
    NEW_FILTER_IMPLANTACAO_ESTOQUE_PEDING,
    NEW_FILTER_IMPLANTACAO_ESTOQUE_SUCCESS,
    NEW_FILTER_IMPLANTACAO_ESTOQUE_FAILURE,
    NEW_FILTER_NEXT_PAGE_IMPLANTACAO_ESTOQUE_PENDING,
    NEW_FILTER_NEXT_PAGE_IMPLANTACAO_ESTOQUE_SUCCESS,
    NEW_FILTER_NEXT_PAGE_IMPLANTACAO_ESTOQUE_FAILURE,
} from './actionTypes';

const initialState = {
    list: null,
    loading: false,
    filter: { rows: CONST_ROWS_PER_PAGE, page: 0, where: '' },
}

function implantacaoEstoqueReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_IMPLANTACAO_ESTOQUE_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_IMPLANTACAO_ESTOQUE_PENDING:
        case FIND_IMPLANTACAO_ESTOQUE_PENDING:
        case DELETE_IMPLANTACAO_ESTOQUE_PENDING:
        case CREATE_IMPLANTACAO_ESTOQUE_PENDING:
        case TABLE_IMPLANTACAO_ESTOQUE_PENDING:
        case NEW_FILTER_IMPLANTACAO_ESTOQUE_PEDING:
        case NEW_FILTER_NEXT_PAGE_IMPLANTACAO_ESTOQUE_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_IMPLANTACAO_ESTOQUE_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_IMPLANTACAO_ESTOQUE_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_IMPLANTACAO_ESTOQUE_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_IMPLANTACAO_ESTOQUE_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_IMPLANTACAO_ESTOQUE_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_IMPLANTACAO_ESTOQUE_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_IMPLANTACAO_ESTOQUE_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_IMPLANTACAO_ESTOQUE_SUCCESS: {
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        }
        case NEW_FILTER_IMPLANTACAO_ESTOQUE_FAILURE: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_NEXT_PAGE_IMPLANTACAO_ESTOQUE_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_NEXT_PAGE_IMPLANTACAO_ESTOQUE_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_IMPLANTACAO_ESTOQUE_SUCCESS:
        case CREATE_IMPLANTACAO_ESTOQUE_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_IMPLANTACAO_ESTOQUE_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { implantacaoEstoqueReducer };